var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 10C19.6875 15.3516 15.3516 19.6875 10 19.6875C4.64844 19.6875 0.3125 15.3516 0.3125 10C0.3125 4.64844 4.64844 0.3125 10 0.3125C15.3516 0.3125 19.6875 4.64844 19.6875 10ZM14.0781 8.87109L11.25 11.8203V4.6875C11.25 4.16797 10.832 3.75 10.3125 3.75H9.6875C9.16797 3.75 8.75 4.16797 8.75 4.6875V11.8203L5.92188 8.87109C5.55859 8.49219 4.95312 8.48438 4.58203 8.85547L4.15625 9.28516C3.78906 9.65234 3.78906 10.2461 4.15625 10.6094L9.33594 15.793C9.70312 16.1602 10.2969 16.1602 10.6602 15.793L15.8438 10.6094C16.2109 10.2422 16.2109 9.64844 15.8438 9.28516L15.418 8.85547C15.0469 8.48438 14.4414 8.49219 14.0781 8.87109Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9a874dd0f2a7500f83a8bda499c68376.svg";
export { ForwardRef as ReactComponent };